import { TDeviceType } from '@cian/ui-kit';

export type TAnalyticsPageType = 'Listing' | 'ListingHybrid' | 'Map';

interface IGetAnalyticsPageTypeParams {
  deviceType: TDeviceType;
  isDesktopListingVisible: boolean;
}

export function getAnalyticsPageType({
  deviceType,
  isDesktopListingVisible,
}: IGetAnalyticsPageTypeParams): TAnalyticsPageType {
  if (deviceType !== 'desktop') {
    return 'Listing';
  }

  return isDesktopListingVisible ? 'ListingHybrid' : 'Map';
}
